<template>
  <div class="main">
    <el-form
      ref="form"
      :model="newFormInline"
      :rules="formRule"
      class="recharge-form"
      label-position="top"
      label-width="120px"
      size="small"
    >
      <!-- 付款方信息 -->
      <div class="form-section">
        <div class="section-title">{{ $t('basicData.PayerInformation') }}</div>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="CNPJ" prop="cnpj">
              <el-input
                v-model="newFormInline.cnpj"
                :placeholder="$t('basicData.PleaseEnterCNPJ')"
                clearable
                @blur="onCnpjBlur"
                @input="onCnpjInput"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
              <!-- TODO: 从CNPJ查询接口获取对应客户列表 -->
              <el-select
                v-model="newFormInline.customerId"
                :disabled="!customerOptions.length"
                :placeholder="$t('basicData.PleaseSelectCustomer')"
                style="width: 100%"
                @change="handleCustomerChange"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('basicData.TopUpAmount')" prop="amount">
              <el-input
                v-model="newFormInline.amount"
                :placeholder="$t('basicData.PleaseEnterAmount')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('basicData.RechargeDate')" prop="rechargeDate">
              <el-date-picker
                v-model="newFormInline.rechargeDate"
                :placeholder="$t('basicData.PleaseSelectRechargeDate')"
                style="width: 100%"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('basicData.SerialNumber')" prop="serialNumber">
              <el-input
                v-model="newFormInline.serialNumber"
                :placeholder="$t('basicData.PleaseEnterBankSerialNumber')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 收款方信息 -->
      <div class="form-section">
        <div class="section-title">{{ $t('basicData.PayeeInformation') }}</div>

        <el-row :gutter="32">
          <el-col :span="12">
            <el-form-item :label="$t('basicData.ReceivingAccount')" prop="bankAccountId">
              <el-select
                v-model="newFormInline.bankAccountId"
                :placeholder="$t('basicData.PleaseSelectReceivingAccount')"
                style="width: 100%"
              >
                <!-- TODO: 从接口获取收款账号列表 -->
                <el-option
                  v-for="item in bankAccountOptions"
                  :key="item.accountNumber"
                  :label="item.companyName"
                  :value="item.accountNumber"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 附件 -->
      <div class="form-section">
        <div class="section-title">
          {{ $t('basicData.annex') }}
        </div>
        <el-row :gutter="32">
          <el-col :span="24">
            <el-form-item prop="receiptFile">
              <UploadCmp
                ref="uploadCmp"
                :auto-upload="true"
                :drag="true"
                :file-size="5"
                :file-type="fileType"
                :is-check-file-type="true"
                :limit="1"
                :show-file-list="true"
                :tips="$t('basicData.UploadTheAttachmentFormat')"
                :upload-text="$t('basicData.UploadBankReceipt')"
                @change="handleUploadSuccess"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="el-form-footer">
      <el-button size="small" @click="cancel">{{ $t('basicData.Cancel') }}</el-button>

      <el-button
        :loading="loading" size="small" style="margin: 0"
        type="primary" @click="save"
      >{{ $t('basicData.Save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { formRule } from '../utils/index';
import UploadCmp from '@/views/claimsManagement/claimStatement/cmp/UploadCmp.vue';
import {
  apiFundAccountCnpj,
  apiFundAccountList,
  apiFundRecharge
} from '@/api/finance/fundManagement';
import i18n from '@/lang';

export default {
  name: 'RechargeForm',

  components: { UploadCmp },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      formRule: {
        ...formRule,
        // 附件必填校验
        receiptFile: [
          {
            required: true,
            validator: (_rule, _value, callback) => {
              if (this.newFormInline.receiptUrl && this.newFormInline.receiptUrl.length > 0) {
                callback();
              } else {
                callback(new Error(i18n.t('basicData.CannotBeEmpty')));
              }
            },
            trigger: ['change', 'blur']
          }
        ]
      },
      // 表单数据
      newFormInline: {
        cnpj: '', // CNPJ——必填，14位数字+字母
        customerId: '',
        customerName: '', // 客户名称——根据CNPJ自动带出
        amount: '', // 充值金额——必填
        rechargeDate: '', // 充值日期——必填
        serialNumber: '', // 流水号——必填
        bankAccountId: '', // 收款账号——必填
        receiptUrl: [] // 银行回执附件——必填
      },
      // 附件文件类型
      fileType: [
        'image/jpeg',
        'image/png',
        'image/bmp',
        'application/pdf'
        // 'application/x-zip-compressed'
      ],
      // 根据CNPJ获取客户信息
      customerOptions: [],
      // 银行账户列表
      bankAccountOptions: []
    };
  },
  watch: {
    'newFormInline.cnpj': {
      handler(val) {
        if (val !== undefined && val !== null && val !== '') {
          // this.onCnpjBlur();
        } else {
          this.newFormInline.customerId = '';
          this.newFormInline.customerName = '';
          this.customerOptions = [];
        }
      },
      flush: 'post'
    },
    visible: {
      handler(newVal) {
        if (newVal) {
          this.getBankAccountList();
          // 清除上传组件的残留文件
          this.$nextTick(() => {
            if (this.$refs.uploadCmp) {
              this.$refs.uploadCmp.clearFiles();
            }
          });
        } else {
          this.$refs.form.resetFields();
          if (this.$refs.uploadCmp) {
            this.$refs.uploadCmp.clearFiles();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * 附件上传成功回调
     * @param {Array} FileList 文件列表
     */
    handleUploadSuccess(FileList) {
      this.newFormInline.receiptUrl = FileList && FileList.length ? FileList : [];
    },

    /**
     * 根据CNPJ获取客户信息
     */
    fetchCustomerByCnpj() {
      if (!this.newFormInline.cnpj) return;
      apiFundAccountCnpj({
        pageSize: 100,
        pageNumber: 1,
        params: {
          cnpjMother: this.newFormInline.cnpj
        }
      })
        .then((res) => {
          if (res.code === 200) {
            this.customerOptions = res?.data?.records || [];
            // 默认匹配首个客户
            if (this.customerOptions.length === 1) {
              this.newFormInline.customerId = this.customerOptions[0]?.id || '';
              this.newFormInline.customerName = this.customerOptions[0]?.username || '';
            } else {
              this.newFormInline.customerId = '';
              this.newFormInline.customerName = '';
            }
          }
        })
        .catch(() => {
          this.customerOptions = [];
        });
    },

    /**
     * 清洗输入：前12位允许字母+数字，最后2位仅允许数字，总长限 14 位
     */
    cleanInput(value) {
      if (!value) return '';

      // 1. 先全局去除所有非字母数字的字符，并转大写
      const raw = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

      // 2. 截取前12位（允许字母和数字）
      const first12 = raw.slice(0, 12);

      // 3. 截取第13位及以后的内容，并强制过滤掉字母，只保留数字
      const last2 = raw.slice(12, 14).replace(/[^0-9]/g, '');

      // 4. 拼接并返回（此时是纯净的14位字符串）
      return (first12 + last2).slice(0, 14);
    },

    // 格式化函数：将 14 位字母数字转为 xx.xxx.xxx/xxxx-xx
    formatCnpj(cnpj) {
      if (!cnpj) return '';
      const cleaned = cnpj.replace(/[^A-Z0-9]/gi, '').toUpperCase();
      if (cleaned.length <= 2) return cleaned;
      if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
      if (cleaned.length <= 8) {
        return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
      }
      if (cleaned.length <= 12) {
        return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
          5,
          8
        )}/${cleaned.slice(8)}`;
      }
      return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(
        8,
        12
      )}-${cleaned.slice(12, 14)}`;
    },

    /**
     * @description CNPJ 失焦事件——根据 CNPJ 自动带出客户名称
     */
    onCnpjBlur() {
      this.fetchCustomerByCnpj();
    },

    /**
     * @description CNPJ格式校验
     * @param {String} value
     * @returns {Boolean}
     */
    onCnpjInput(value) {
      console.log('CNPJ 失焦事件', value);
      // 先清洗得到纯净字符串，再格式化，最后存入 model
      const cleaned = this.cleanInput(value);
      this.newFormInline.cnpj = this.formatCnpj(cleaned);
    },

    /**
     * 取消
     */
    cancel() {
      this.$emit('close');
    },

    /**
     * 保存
     */
    async save() {
      try {
        const valid = await this.$refs.form.validate().catch(() => false);
        if (!valid) return;
        // 校验附件是否已上传
        if (!this.newFormInline.receiptUrl || this.newFormInline.receiptUrl.length === 0) {
          this.$message.warning(this.$t('basicData.fileUpload'));
          return;
        }
        this.loading = true;
        const receiptUrl = this.newFormInline.receiptUrl.map(({ name, url }) => ({ name, url }));
        const data = {
          cnpj: this.newFormInline.cnpj,
          customerId: this.newFormInline.customerId,
          customerName: this.newFormInline.customerName,
          amount: this.newFormInline.amount,
          rechargeDate: this.newFormInline.rechargeDate,
          serialNumber: this.newFormInline.serialNumber,
          bankAccountId: this.newFormInline.bankAccountId,
          receiptUrl
        };

        const res = await apiFundRecharge(data);
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
          this.$emit('close');
        }
      } catch (err) {
        console.error('充值提交失败:', err);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 客户下拉变更时同步 customerName
     */
    handleCustomerChange(val) {
      const customer = this.customerOptions.find((item) => item.id === val);
      if (customer) {
        this.newFormInline.customerName = customer.username || '';
      } else {
        this.newFormInline.customerName = '';
      }
    },

    /**
     * 获取银行账户列表
     */
    getBankAccountList() {
      apiFundAccountList()
        .then((res) => {
          if (res.code === 200) {
            this.bankAccountOptions = res.data || [];
          }
        })
        .catch(() => {
          this.bankAccountOptions = [];
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.recharge-form {
  padding: 16px;
  height: calc(100vh - 125px);
  overflow-y: auto;

  .form-section {
    margin-bottom: 15px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #e20d0d;
      margin-bottom: 10px;
    }
  }

  .upload-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }

  .tip-alert {
    margin-top: 10px;
  }
}

.main {
  .el-form-footer {
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px 16px;
  }
}
</style>
